import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import { fetchOpenContainers, fetchExpiringContainers, openContainer, finishContainer } from "./openContainerThunk";

interface OpenContainerSliceState {
  containers: any[];
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: OpenContainerSliceState = { containers: [], status: ApiStatus.IDLE, errorMessage: "" };

const openContainerSlice = createSlice({
  name: "openContainer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpenContainers.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchOpenContainers.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.containers = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchOpenContainers.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(fetchExpiringContainers.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchExpiringContainers.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.containers = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchExpiringContainers.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(openContainer.fulfilled, () => { toast.success("Container opened"); })
      .addCase(openContainer.rejected, (state, action) => { toast.error(action.error.message || "Failed to open container"); })
      .addCase(finishContainer.fulfilled, () => { toast.success("Container finished"); })
      .addCase(finishContainer.rejected, (state, action) => { toast.error(action.error.message || "Failed to finish"); });
  },
});

export default openContainerSlice.reducer;
